// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, FormControl, MenuItem, Select, useMediaQuery } from '@mui/material';

// project imports
import LAYOUT_CONST from '@/constant';
import useConfig from '@/hooks/useConfig';
import LogoSection from '../LogoSection';
//import MobileSection from './MobileSection';
import NotificationSection from './NotificationSection';
import ProfileSection from './ProfileSection';
import useHeader from './useHeader';
import { openDrawer } from '@/store/slices/menu';

// assets
import { IconMenu2 } from '@tabler/icons-react';
// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {
    const theme = useTheme();
    const {
        drawerOpen,
        dispatch,
        availableHospitals,
        selectedHospitalId,
        shouldShowHospitalSelector,
        shouldShowNotifications,
        isHospitalSelectorDisabled,
        handleHospitalChange
    } = useHeader();
    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
    const { layout } = useConfig();

    return (
        <>
            <Box
                sx={{
                    width: 220, // TODO: Make this dynamic based on the logo size. 350 is best for subHeading with 2 liner.
                    display: 'flex',
                    alignItems: 'center',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
                <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                    <LogoSection />
                </Box>
                {(layout === LAYOUT_CONST.VERTICAL_LAYOUT || (layout === LAYOUT_CONST.HORIZONTAL_LAYOUT && matchDownMd)) && (
                    <Avatar
                        variant="rounded"
                        sx={{
                            ...theme.typography.commonAvatar,
                            ...theme.typography.mediumAvatar,
                            overflow: 'hidden',
                            transition: 'all .2s ease-in-out',
                            background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.secondary.light,
                            color: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
                            '&:hover': {
                                background: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
                                color: theme.palette.secondary.light
                            }
                        }}
                        onClick={() => dispatch(openDrawer(!drawerOpen))}
                        color="inherit"
                    >
                        <IconMenu2 stroke={1.5} size="20px" />
                    </Avatar>
                )}
            </Box>
            {shouldShowHospitalSelector && (
                <FormControl size="small" sx={{ width: { sx: 120, sm: 240 }, ml: { xs: 1, md: 3 }, mr: 1.5 }}>
                    <Select
                        value={selectedHospitalId}
                        onChange={handleHospitalChange}
                        disabled={isHospitalSelectorDisabled}
                        displayEmpty
                        MenuProps={{
                            slotProps: {
                                paper: {
                                    sx: {
                                        maxHeight: 300
                                    }
                                }
                            }
                        }}
                        renderValue={(selected) => {
                            if (!selected) {
                                return 'Select Hospital';
                            }
                            return availableHospitals.find((hospital) => hospital.id === selected)?.name ?? 'Select Hospital';
                        }}
                        sx={{
                            '& .MuiSelect-select': {
                                display: 'flex',
                                alignItems: 'center',
                                py: 1
                            }
                        }}
                    >
                        {availableHospitals.map((hospital) => (
                            <MenuItem key={hospital.id} value={hospital.id}>
                                {hospital.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
            <Box sx={{ flexGrow: 1 }} />
            {/* notification & profile */}
            {shouldShowNotifications && <NotificationSection />}
            <ProfileSection />
        </>
    );
};

export default Header;
